import React from 'react';
import styles from '../Operations.module.css';

interface MGOBComponent extends React.FC {
  title?: string;
  kpiHyperlink?: string;
  actionTitle?: string;
  actionHyperlink?: string;
}

/**
 * MGOB - Obsolete
 * KPI information component
 */
const MGOB: MGOBComponent = () => {
  return (
    <div className={styles.container}>
      <div className={styles.sectionTitle}>Metric Description</div>

      <div className={styles.sectionContent}>
        Obsolete inventory is merchandise that does not have any true or anticipated demand.
        Carrying the cost of dead items causes a drag on all of your financial ratios. Every store needs to create a plan to recapture cash from dead inventory, to reinvest in
        inventory that turns. In recent years the lifecycle of products has diminished, especially in housewares and
        decor. Today&apos;s hot item is tomorrow&apos;s dead item.
      </div>

      <div className={styles.sectionContent}>
        Closeout Management (COM) is the process in which to manage and erase these Obsolete items
        from your store. This process takes the Obsolete SKUs into a markdown cadence designed to help get the
        maximum dollar recovery per item and getting these dead items out of your store!
      </div>

      <div className={styles.sectionContent}>
        For a SKU to appear on this list, they have not sold in over 24 months.
        <br />
        <br />
        Note: Discovery Merchandise is not shown in this metric.
      </div>

      <div className={styles.sectionTitle}>Supporting Details</div>

      <div className={styles.sectionContent}>
        By liquidating obsolete inventory, your store looks fully stocked with clean, in-demand
        items. Customer visits are enhanced when they can count on finding interesting, updated
        product assortments.
        <ul>
          <li>
            Merchandise sitting on a shelf costs money. It is not unusual for a retailer whose
            inventory has not been reviewed over a period of time to find that 20-25% of the
            store&apos;s total items are non-performers.
          </li>
          <li>
            Even a store that has a plan for managing obsolete inventory could have 5-10% of total
            inventory in non-performing merchandise. There are a number of reasons for this, many of
            which are almost unavoidable.
          </li>
        </ul>
      </div>

      <div className={styles.sectionTitle}>Goal</div>

      <div className={styles.sectionContent}>Obsolete Inventory is &lt; 4.5%</div>

      <div className={styles.sectionTitle}>Learn More</div>

      <div className={styles.sectionContent}>
        1) Click on your current <strong>Obsolete %</strong> linked to the Closeout Management Main
        Grid.
        <br />
        <br />
        2) Displayed in this grid are the top 100 SKUs with no sales in 24 months, with the highest
        dollar value to recover.
        <br />
        <br />
        3) Print the current grid out and Interview each SKU, while taking notes on which action you
        wish to take.
        <br />
        Actions available:
        <br />
        <div className={styles.indented}>
          <strong>Start COM</strong> - This will begin the 4 week markdown cadence and closeout the
          SKU.
          <br />
          <strong>Exclude COM SC=Y</strong> - This will close out the SKU without putting it through
          the 4 week markdown cadence
          <br />
          <strong>Exclude COM SC=N</strong> - This will take the SKU off the list altogether and no
          changes will be made.
          <br />
          <strong>No Change</strong> - This will remove the SKU from this month&apos;s list, but
          will allow the SKU to return on the next months listing.
          <br />
          <strong>Note:</strong> If you wish to add additional SKUs to the listing click the Add
          SKUs button in the top left corner and type the SKU you will to add into the grid.
        </div>
        <br />
        4) By clicking on the radio button in the Change Minimum Order Point column you now have
        this SKU selected to accept the Suggested MOP.
        <br />
        <div className={styles.indented}>
          <strong>Note:</strong> If you select a SKU or SKUs and need to exit the screen without
          submitting, your selections will be saved and reappear as you left them.
        </div>
        <br />
        5) Once you have made the choices on SKUs you wish to change and are ready to submit, there
        is a red Submit button on the top right of the grid, click this button.
        <br />
        <br />
        6) After clicking the button, you will receive a{' '}
        <strong>selections successfully submitted</strong> message that will be your cue to know
        that all changes have now been made to your Eagle system in IMU.
        <br />
        <br />
        7) For any SKUs that have not been submitted or acted upon, they will remain in the grid to
        be revisited in the future.
        <br />
        <br />
        For further information on the process and procedures please view Ace Way of Retailing{' '}
        <a
          href="https://acenet.aceservices.com/awor/unproductive-inventory/obsolete-inventory"
          target="_blank"
          rel="noopener noreferrer"
          className={styles.link}>
          Obsolete Inventory
        </a>.
      </div>
    </div>
  );
};

MGOB.title = 'Obsolete/Closeout Management';
MGOB.kpiHyperlink = 'dynamicURL:ACENET:description';
MGOB.actionTitle = 'Start Closeout Management';
MGOB.actionHyperlink = 'dynamicURL:ACENET:current';
export default MGOB;
